<template>
  <div >
    <div class="shckDialog" >
      <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible="dialogFormVisible"
        center
        title=""
        @close="$emit('close-dialog')"
      >
        <div style="font-weight: bold; font-size: 20px; text-align: center">
          {{ childrenType }}损耗出库
        </div>
        <el-form
          ref="form"
          v-loading="loading"
          :model="form"
          :rules="rules"
          :inline="true"
          label-width="88px"
        >
          <el-form-item label="化学品:" prop="hxpBm">
            <el-cascader
              v-if="!(ckdisable || bgdisable)"
              v-model="form.hxpBm"
              style="width: 100%"
              :options="options"
              clearable
              :disabled="ckdisable || bgdisable"
              placeholder="请选择化学品"
              :props="{ emitPath: false }"
              filterable
              @change="hxpOptionsChange"
            />
            <el-input
              v-else
              v-model="form.hxpMc"
              disabled
            />
          </el-form-item>

          <el-form-item label="存放仓库:" prop="ckId">
            <el-select
              v-if="!ckdisable"
              v-model="form.ckId"
              placeholder="请选择"
              :disabled="shcktype || ckdisable"
              @change="ckChange"
            >
              <el-option
                v-for="item in ckList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-input
              v-else
              v-model="form.ckmc"
              disabled
            />
          </el-form-item>
          <el-form-item label="损耗数量:" class="is-required">
            <el-form-item prop="cksl" style="width: 266px; margin-right: 10px">
              <el-input
                v-model="form.cksl"
                type="number"
                :disabled="shcktype || ckdisable"
                placeholder="请输入"
              />
              <!-- </el-form-item>

          <el-form-item prop="ckslDw" style="width: 100px"> -->
              <el-select
                v-model="form.ckslDw"
                placeholder="单位"
                :disabled="shcktype || ckdisable"
                @change="shlsChange"
              >
                <el-option
                  v-for="item in dwlxList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                /> </el-select></el-form-item>
          </el-form-item>
          <el-form-item v-if="!ckdisable" label="当前库存:" prop="kcl">
            <el-input
              v-model="form.kcl"
              disabled
              placeholder="请输入"
            />
            <el-select v-model="form.kclDw" placeholder="单位" disabled>
              <el-option
                v-for="item in dwlxList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="保管员姓名:"
          >
            <el-input
              style="width: 100% !important"
              v-model="form.bgyxm"
              disabled
              placeholder="请输入"
            />
          </el-form-item>

          <el-form-item label="出库日期:" prop="ckrq">
            <el-date-picker
              v-model="form.ckrq"
              style="width: 100%"
              :picker-options="pickerBeginDateBefore"
              :disabled="shcktype || ckdisable"
              type="date"
              placeholder="请选择"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
          <el-form-item
            required
            label="经办人:"
            prop="jbrId"
          >
            <el-select
              v-if="!(ckdisable || bgdisable)"
              v-model="form.jbrId"
              filterable
              placeholder="选择经办人"
              :disabled="shcktype || ckdisable || bgdisable"
              @change="jbrChange"
            >
              <el-option
                v-for="item in lyrList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-input
              v-else
              v-model="form.jbrName"
              disabled
            />
          </el-form-item>

          <el-form-item
            label="损耗原因:"
            prop="shyy"
            :rules="{
              required: true,
              validator: (rule, value, callback) => {
                lengthValidate(rule, value, callback, 'bt', 500);
              },
              trigger: ['blur', 'change'],
            }"
          >
            <el-input
              v-model="form.shyy"
              :disabled="shcktype || ckdisable || bgdisable"
              type="textarea"
              :rows="3"
              resize="none"
              placeholder="请填写原因"
            />
          </el-form-item>

          <el-form-item
            v-if="djsjshow"
            class="is-required"
            style="width: 48%"
            label="登记时间:"
            prop="djsj"
          >
            <el-input
              v-model="form.djsj"
              disabled
              placeholder="请填写"
            />
          </el-form-item>
          <el-form-item v-else label="登记时间:" style="width: 48%;">
            <el-date-picker
              :value="new Date()"
              type="date"
              style="width: 100%;"
              placeholder="选择日期"
              disabled
              format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
          <el-form-item
            v-if="childrenType == '新增'"
            label="登记人:"
            class="is-required"
            required
          >
            <el-input v-model="djr" disabled placeholder="" />
          </el-form-item>
          <el-form-item v-else label="登记人:" class="is-required">
            <el-input
              v-model="form.djrLabel"
              disabled
              placeholder=""
            />
          </el-form-item>

          <el-form-item
            label="备注:"
            style="width: 100%"
            prop="bz"
            :rules="{
              validator: (rule, value, callback) => {
                lengthValidate(rule, value, callback, 'xt', 255);
              },
              trigger: ['blur', 'change'],
            }"
          >
            <el-input
              v-model="form.bz"
              :disabled="shcktype || ckdisable || bgdisable"
              placeholder="请填写"
            />
          </el-form-item>

          <el-form-item label="证明材料:" required class="tpcontent">
            <el-upload
              class="avatar-uploader"
              :headers="token"
              :action="returnSaveFile"
              :limit="6"
              list-type="picture-card"
              :disabled="ckdisable || bgdisable"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :on-success="handleAvatarSuccess"
              :on-exceed="handleExceed"
              :on-change="handleprogress"
              :file-list="fileList"
              :before-upload="beforeUpload"
            >
              <i class="el-icon-plus avatar-uploader-icon" />
            </el-upload>
            <el-dialog
              :close-on-click-modal="false"
              :close-on-press-escape="false"
              :visible.sync="dialogVisible"
              append-to-body
            >
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
          </el-form-item>

          <el-form-item
            v-if="bgdisable"
            label="变更理由:"
            prop="bgly"
            style="width: 100%"
            class="is-required tpcontent"
            :rules="{
              required: true,
              validator: (rule, value, callback) => {
                lengthValidate(rule, value, callback, 'bt', 1000);
              },
              trigger: ['blur', 'change'],
            }"
          >
            <el-input
              v-model="form.bgly"
              type="textarea"
              :rows="3"
              resize="none"
              placeholder="请输入"
            />
          </el-form-item>
        </el-form>
        <div style="width: 80%; margin: 0 auto" v-loading="loading">
          <splcCom
            v-if="childrenType == '查看' || childrenType == '变更'"
            ref="splcRef"
          />
        </div>
        <div class=""  v-loading="loading" style="width: 80%; margin: 0 auto">
          <div
            v-if="curRowObj.bgcs >= 1"
            class="title"
            style="margin: 40px 0 50px 0"
          >
            <img src="../../assets/img/bgsp/ckbg.png" alt="" srcset="">
          </div>
          <bgcsOfDetail
            v-if="curRowObj.bgcs >= 1"
            :cur-row-obj="curRowObj"
            :cur-type="curType"
            :bgcs-t-k-name="'disShow'"
            @bacsCkXqShow="bacsCkXqShow"
          />
        </div>

        <div
          v-loading="loading"
          v-if="
            (!djsjshow && !ckdisable && !bgdisable) ||
              (djsjshow && !ckdisable && !bgdisable)
          "
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            v-preventReClick
            @click="confirmTemp"
          >暂时保存</el-button>
          <el-button
            v-preventReClick
            type="primary"
            @click="confirm('form', 'ck')"
          >出库</el-button>
        </div>
        <!-- 查看 -->
        <div v-loading="loading" v-if="djsjshow && ckdisable && !bgdisable" class="backButton">
          <el-button
            v-preventReClick
            type="primary"
            @click="confirm('form', '')"
          >确定</el-button>
        </div>
        <!-- 变更 -->
        <div v-loading="loading" v-if="djsjshow && !ckdisable && bgdisable" class="backButton">
          <el-button
            v-preventReClick
            type="primary"
            @click="confirm('form', 'bg')"
          >提交变更</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 详情弹框 -->
    <el-dialog :visible.sync="dialogFormVisible_bg" width="1200px" center>
      <bgxqCom
        v-if="dialogFormVisible_bg"
        bgcs-t-k-name="损耗出库"
        :dgcs-xq-id="dgcsXqId"
      />
      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          type="primary"
          style="background-color: #4170ff; border: none"
          @click="dialogFormVisible_bg = false"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { lengthValidate } from '@/assets/js/validate'
import bgxqCom from '@/components/bgxq/bgxqCom.vue'
import bgcsOfDetail from '@/components/bgxq/bgInDetail.vue'
import splcCom from '../bgxq/splccom.vue'
import {
  url1,
  getToken,
  returnSaveFile,
  returnShowPic,
  gethxpJl,
  getshckDetailMes,
  lyrOptions,
  ckOptions,
  addorsaveshckMes,
  changejcshckMes,
  changeshckMes,
  userInfofLogin, addorsaveshckMesTemp
} from '@/assets/js/common.js'
import { getdwforhxpBm } from '@/assets/js/yssq'
export default {
  name: 'ShcklbDialog',
  components: { bgcsOfDetail, bgxqCom, splcCom },
  props: {
    dialogFormVisible: {
      type: Boolean
    },
    shcktype: {
      type: Boolean
    },
    djsjshow: {
      type: Boolean
    },
    ckdisable: {
      type: Boolean
    },
    bgdisable: {
      type: Boolean
    },
    childrenType: {
      type: String
    },
    rowId: {
      type: String
    }
  },
  data() {
    return {
      loading: false,
      shsl_temp_dw: null, // 损耗数量单位
      ckl_temp: null, // 当前的库存量
      // 日期限制
      pickerBeginDateBefore: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      // 日期限制
      token: {
        Authorization: getToken()
      },
      returnSaveFile: '', // 返回保存图片路径
      returnShowPic: '', // 返回回显图片路径
      form: {
        id: '',
        hxpBm: '', // 化学品
        ckId: '', // 存放仓库id
        ckmc: '',
        ckbh: '',
        cksl: '', // 损耗数量
        ckslDw: '', // 损耗数量单位
        kcl: '',
        kclDw: '',
        kclDwLabel: '',
        bgyId: '',
        bgyxm: '',
        bgydh: '',
        ckrq: '', // 日期
        jbrId: '',
        jbrName: '',
        shyy: '', // 损耗原因
        bz: '', // 备注
        djrLabel: '',
        djsj: '',
        zt: '',
        bgly: '',
        addFjDto: [],
        delFjDto: [],
        ckShckFjDtos: []
      },
      djr: '',
      rules: {
        hxpBm: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] }
        ], // 化学品
        ckId: [
          { required: true, message: '请选择', trigger: ['blur','change'] }
        ], // 存放仓库
        cksl: [
          {
            required: true,
            validator: (rule, value, callback) => {
              let shsl_temp = null // 临时的损耗数量
              // 如果是查看的时候

              if (this.childrenType == '查看') {
                return callback()
              }

              if (this.shsl_temp_dw == '吨') {
                shsl_temp = this.form.cksl * 1000 * 1000
              } else if (
                this.shsl_temp_dw == '千克' ||
                this.shsl_temp_dw == '升'
              ) {
                shsl_temp = this.form.cksl * 1000
              } else if (
                this.shsl_temp_dw == '克' ||
                this.shsl_temp_dw == '毫升'
              ) {
                shsl_temp = this.form.cksl
              }

              // console.log('损耗数量'+this.form.cksl,'库存量'+this.ckl_temp,'损耗数量单位'+this.shsl_temp_dw)
              if (!(this.form.cksl + '')) {
                return callback(new Error('请输入损耗数量值'))
              }
              const reg = /^(0|[1-9][0-9]*)(\.\d+)?$/
              if (!this.bgdisable && !reg.test(this.form.cksl)) {
                callback(new Error('请输入大于或等于0的数量值'))
              } else if (
                /^-?[1-9]\d{0,8}(\.\d{1,3})?$|^-?0(\.\d{1,3})?$/.test(value) ==
                false
              ) {
                return callback(new Error('整数位最大长度9位,保留3位小数'))
              } else if (!this.form.ckslDw) {
                return callback(new Error('请选择损耗数量单位'))
              } else if (
                shsl_temp > this.ckl_temp &&
                !(this.childrenType == '变更')
              ) {
                return callback(new Error('损耗数量不能大于当前库存量'))
              }
              callback()
            },
            trigger: ['blur','change']
          }
        ],
        ckslDw: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!this.form.ckslDw) {
                return callback(new Error('请选择单位'))
              }
              callback()
            },
            trigger: ['blur', 'change']
          }
        ],
        ckslbg: [
          { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],
        jbrId: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] }
        ], //
        ckrq: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] }
        ] // 报备日期
        // shyy: [
        //   { required: true, message: "请输入", trigger: ["blur", "change"] },
        // ], // 损耗原因

        // bgly: [{ required: true, message: "请输入", trigger: ["blur"] }],
      },
      fileList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      ckList: [], // 仓库
      lyrList: [], // 领用人
      options: [], // 化学品
      dwlxList: [], // 单位
      addFjxxs: [], // 添加的图片
      delFjxxs: [], // 删除的图片id

      curType: '',
      curRowObj: {}, // 当前行的对象
      dialogFormVisible_bg: false,
      dgcsXqId: null
    }
  },
  watch: {
    'form.hxpBm': {
      deep: true,
      handler(val) {
        if (val) {
          getdwforhxpBm(this.form.hxpBm).then((e) => {
            this.dwlxList = e.data.data
          })
        }
      }
    },
    'fileList.length': {
      deep: true,
      handler(val) {
        if (this.fileList.length >= 6 || this.ckdisable) {
          document.getElementsByClassName(
            'el-upload--picture-card'
          )[0].style.display = 'none'
        } else {
          document.getElementsByClassName(
            'el-upload--picture-card'
          )[0].style.display = 'inline-block'
        }
      }
    }
  },
  created() {
    this.URL1 = url1()
    this.returnSaveFile = returnSaveFile()
    this.returnShowPic = returnShowPic()
    gethxpJl().then((res) => {
      if (res.status == 200) {
        this.options = res.data.data
      }
    })
    if(this.childrenType == '新增'){
      lyrOptions().then((res) => {
        if (res.status == 200) {
          this.lyrList = res.data.data
        }
      })
    }

    userInfofLogin().then((res) => {
      if (res.status == 200) {
        this.djr = res.data.data.name
      }
    })
  },
  mounted() {
    this.getInformationByType() // 根据类型获取表单项
  },
  methods: {
    lengthValidate,
    // 变更次数
    bacsCkXqShow(id) {
      this.dgcsXqId = id
      this.dialogFormVisible_bg = !this.dialogFormVisible_bg
    },
    initCon(curRow, curType) {
      this.curRowObj = curRow
      this.curType = curType
      this.dialogFormVisibl = false
    },
    shlsChange(val) {
      this.dwlxList.forEach((item) => {
        if (val == item.value) {
          this.shsl_temp_dw = item.label
        }
      })
    },
    getshckDetailMess() {
      getshckDetailMes(this.rowId).then((res) => {
        if (res.status == 200) {
          if(this.childrenType == '查看'){
            this.form = res.data.data
          }else{
            let mesxx = {...res.data.data}
            mesxx.ckId = this.form.ckId
            mesxx.ckmc = this.form.ckmc
            mesxx.bgyId = this.form.bgyId
            mesxx.bgydh = this.form.bgydh
            mesxx.bgyxm = this.form.bgyxm
            mesxx.kcl = this.form.kcl
            mesxx.kclDw = this.form.kclDw
            mesxx.kclDwLabel = this.form.kclDwLabel
            if( this.childrenType != '变更'){
              mesxx.jbrId = this.form.jbrId
              mesxx.jbrName = this.form.jbrName
            }
            this.form = mesxx
            this.ckOptions(this.form.hxpBm,res.data.data)
          }
          if (this.childrenType == '查看' || this.childrenType == '变更') {
            this.$refs.splcRef.dataobj = res.data.data.sphjDtoList
          }
          if (this.form.kclDwLabel == '吨') {
            this.ckl_temp = this.form.kcl * 1000 * 1000
          } else if (
            this.form.kclDwLabel == '千克' ||
            this.form.kclDwLabel == '升'
          ) {
            this.ckl_temp = this.form.kcl * 1000
          } else if (
            this.form.kclDwLabel == '克' ||
            this.form.kclDwLabel == '毫升'
          ) {
            this.ckl_temp = this.form.kcl
          }

          this.shsl_temp_dw = res.data.data.ckslDwLabel
          this.form.ckShckFjDtos.forEach((item) => {
            this.fileList.push({
              id: item.id,
              url: this.returnShowPic + item.wjdz
            })
          })
          this.yssl = this.form.cksl
        }
        this.$nextTick(() => {
          this.$refs.form.clearValidate() //清楚页面所有校验结果
        })
      })
    },
    getInformationByType() {
      if (this.childrenType == '新增') {
      } else if (this.childrenType == '查看') {
        this.getshckDetailMess()
      } else if (this.childrenType == '编辑') {
        this.getshckDetailMess()
      } else if (this.childrenType == '变更') {
        // this.$nextTick(() => {
        //   this.$refs["form"].rules.cksl = this.$refs["form"].rules.ckslbg;
        // });
        this.getshckDetailMess()
      }
    },
    reset() {
      this.$parent.search()
      this.$emit('close-dialog')
    },
    bgSub() {
      // 变更校验
      changejcshckMes(this.form).then((res) => {
        var data = '是否确认变更?'
        console.log(res.data.data, '12312312++++')
        if (res.data.data.type == 'success') {
        } else {
          data =
            "<span style='color:red'>" +
            res.data.data.msg +
            '</span>是否确认变更?'
        }
        this.$confirm(data, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
          type: 'warning',
          center: true
        }).then((res) => {
          this.loading = true
          changeshckMes(this.form).then((res) => {
            this.loading = false
            if (res.status == 200) {
              this.$message.success('变更成功')
              this.reset()
            } else {
              return
            }
          }).catch((error) => {
            this.loading = false
          })
        })
      })
    },
    sljy() {
      var flag = true
      // if (this.form.ckslDw < this.form.kclDw) {
      //   if (
      //     this.form.cksl * (this.form.kclDw - this.form.ckslDw) * 1000 >
      //     this.form.kcl
      //   ) {
      //     this.$message.error("超出库存数量");
      //     flag = false;
      //   }
      // } else if (this.form.ckslDw > this.form.kclDw) {
      //   if (
      //     this.form.cksl * (this.form.ckslDw - this.form.kclDw) * 0.001 >
      //     this.form.kcl
      //   ) {
      //     this.$message.error("超出库存数量");
      //     flag = false;
      //   }
      // } else if (this.form.ckslDw == this.form.kclDw) {
      //   if (this.form.cksl > this.form.kcl) {
      //     this.$message.error("超出库存数量");
      //     flag = false;
      //   }
      // }
      return flag
    },
    //暂时保存
    confirmTemp() {
      if (this.childrenType == '查看') {
        this.reset()
        return
      }
      this.form.addFjDto = this.addFjxxs
      this.form.delFjDto = this.delFjxxs
      this.form.zt = '00'
      this.$confirm('确认暂时保存吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then((res) => {
        this.loading = true
        addorsaveshckMesTemp(this.form).then((e) => {
          this.loading = false
          this.$message.success('暂时保存成功')
          this.reset()
        }).catch((error) => {
          this.loading = false
        })
      })
    },
    //出库
    confirm(formName, type) {
      if (this.childrenType == '查看') {
        this.reset()
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.childrenType != '变更' && this.fileList.length == 0) {
            this.$message.error('请上传证件材料')
            return false
          }
          var flag = this.sljy()
          if (!flag) return false
          this.form.addFjDto = this.addFjxxs
          this.form.delFjDto = this.delFjxxs
          if (this.childrenType == '新增' || this.childrenType == '编辑') {
            this.form.zt = type == 'zsbc' ? '00' : '01'
            this.$confirm('确认提交吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }).then((res) => {
              this.loading = true
              addorsaveshckMes(this.form).then((e) => {
                this.loading = false
                this.$message.success('保存成功')
                this.reset()
              }).catch((error) => {
                this.loading = false
              })
            })
          } else if (this.childrenType == '变更') {
            if (this.form.bgly) this.bgSub()
            // else {
            //   this.$message.error("请填写变更原因");
            //   return false;
            // }
          }
        } else {
          return false
        }
      })
    },
    // 仓库改变
    ckChange(ckValue) {
      this.ckList.forEach((item) => {
        if (ckValue == item.value) {
          this.form.ckId = item.value
          this.form.ckmc = item.label
          this.form.kcl = item.kcl
          this.form.kclDw = item.kclDw
          this.form.kclDwLabel = item.kclDwLabel
          // 库存单位
          if (this.form.kclDwLabel == '吨') {
            this.ckl_temp = this.form.kcl * 1000 * 1000
          } else if (
            this.form.kclDwLabel == '千克' ||
            this.form.kclDwLabel == '升'
          ) {
            this.ckl_temp = this.form.kcl * 1000
          } else if (
            this.form.kclDwLabel == '克' ||
            this.form.kclDwLabel == '毫升'
          ) {
            this.ckl_temp = this.form.kcl
          }
          this.form.bgyxm = item.ckbgy
          this.form.bgyId = item.ckbgyId
          this.form.bgydh = item.ckbgyDh
        }
      })
    },
    jbrChange(val) {
      this.lyrList.forEach((item) => {
        if (val == item.value) {
          this.form.jbrName = item.label
        }
      })
    },
    // 化学品改变  // 切换化学品的时候其他关联字段清空
    hxpOptionsChange(val) {
      this.form.ckId = ''
      this.form.ckmc = ''
      this.form.kcl = ''
      this.form.kclDw = ''
      this.form.kclDwLabel = ''
      this.form.bgyxm = ''
      this.form.bgydh = ''
      this.form.bgyId = ''
      this.form.ckslDw = ''
      this.ckOptions(val)
    },
    ckOptions(val,dataMes) {
      if(this.bgdisable){ //变更
        ckOptions(val,dataMes.ckId).then((res) => {
          if (res.status == 200) {
            this.ckList = res.data.data
            this.ckChange(dataMes.ckId)
          }
        })
      }else{
        if(val){
          ckOptions(val).then((res) => {
            if (res.status == 200) {
              this.ckList = res.data.data
              if(dataMes && dataMes.ckId){
                this.ckChange(dataMes.ckId)
              }
            }
          })
        }
        if(dataMes){
          lyrOptions().then((res) => {
            if (res.status == 200) {
              this.lyrList = res.data.data
              this.lyrList.findIndex((item) => {
                if(item.value == dataMes.jbrId){
                  this.form.jbrId = dataMes.jbrId
                  this.form.jbrName = dataMes.jbrName
                  return
                }
              })
            }
          })
        }
      }

    },
    // 成功
    handleAvatarSuccess(res, file) {
      this.addFjxxs.push({
        wjdz: res.data.url
      })
    },
    // 预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    // 上传之前
    beforeUpload(file) {
      const fileType = ['image/jpeg', 'image/png', 'image/bmp', 'image/jpg']
      const isJPG = fileType.includes(file.type)

      const isLt = file.size / 1024 < 500
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/BMP/JPEG/PNG格式!')
      }
      if (!isLt) {
        this.$message.error('上传图片大小不能超过 500kb!')
      }
      return isJPG && isLt
    },
    // 移除
    handleRemove(file, fileList) {
      this.fileList = fileList
      // file包含id时，将删除主键存取
      if (file.id) {
        this.delFjxxs.push({
          id: file.id
        })
      } else {
        if (file.url.includes(this.returnShowPic)) {
          this.addFjxxs.filter((item, index) => {
            if (item.wjdz == file.url.split('=')[1]) { this.addFjxxs.splice(index, 1) }
            return
          })
        }
        // 新上传未回显
        else if (file.response) {
          this.addFjxxs.filter((item, index) => {
            if (item.wjdz == file.response.data.url) { this.addFjxxs.splice(index, 1) }
            return
          })
        }

        // //删除的为未提交过得文件
        // var indeximage = this.addFjxxs.forEach((item, index) => {
        //   if (item.wjdz == file.response.data.url) return index;
        // });
        // this.addFjxxs.splice(indeximage, 1);
      }
    },
    // 文件改变时
    handleprogress(file, fileList) {
      this.fileList = fileList
    },
    // 限制
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 6 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      )
    }
  }
}
</script>

<style lang="less" scoped>
.shckDialog {
  /deep/ .el-dialog {
    width: 1200px;

    .el-dialog__body {
      padding: 0;
      .el-form {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 47px 118px 0;
        .el-form-item {
          margin-right: 0px;
          .el-form-item__content {
            width: 376px !important;
            .el-select {
              width: 100%;
            }
          }
          &:nth-child(4),
          &:nth-child(3) {
            .el-form-item__content {
              & > .el-input {
                width: 265px !important;
                margin-right: 10px;
              }
              .el-select {
                width: 100px !important;
              }
            }
          }
          &:nth-child(6) {
            .el-form-item__label {
              width: 100px !important;
            }
          }
          &:nth-child(7),
          &:nth-child(8),
          &:nth-child(9) {
            width: 100%;
            .el-form-item__content {
              width: calc(100% - 88px) !important;
              & > .el-input {
                width: 100% !important;
              }
            }
          }
          &:nth-child(11) {
            .el-form-item__content {
              width: 875px !important;
            }
          }
          .el-button--primary {
            width: 63px;
            height: 31px;
            padding: 4px 0;
            // line-height: 31px;
            background: #4170ff;
            border-radius: 2px;
          }
        }
        .tpcontent {
          .el-form-item__content {
            width: calc(100% - 88px) !important;
          }
        }
      }
    }
    .el-dialog__footer {
      padding-bottom: 72px;
      .el-button {
        width: 148px;
        height: 60px;
        background: #4170ff;
        border-radius: 5px;
        margin: 0 95px;
        &:nth-child(1) {
          background: #ebebeb;
        }
      }
    }
  }
}
.backButton {
  width: 148px;
  margin: 30px auto 40px auto;
  .el-button {
    margin: 30px auto;
    background-color: #4170ff;
    width: 148px;
    height: 60px;
    color: white;
    border: none;
  }
}

/deep/.avatar-uploader .el-upload {
  border: 0 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader {
  height: 96px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
/deep/.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 96px !important;
  height: 96px !important;
  line-height: 96px !important;
  text-align: center;
  background: #f3f3f3;
  border-radius: 3px;
}
/deep/.el-upload {
  line-height: 96px !important;
}
.avatar {
  display: block;
}

/deep/.el-upload-list--picture-card .el-upload-list__item,
/deep/.el-upload--picture-card {
  width: 96px !important;
  height: 96px !important;
}
/deep/input::-webkit-outer-spin-button,
/deep/input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
/deep/input[type="number"] {
  -moz-appearance: textfield;
}
</style>
